import { useInfiniteQuery, useQuery } from "@tanstack/react-query";

import { GO_SERVICE_QUERY_KEYS } from "../queryKeys";
import { getReceivedProgramRequests } from "../services/goHireService";

const REQUESTS_PAGE_LIMIT = 3;

interface UseProgramRequestsParams {
  limit?: number;
  offset?: number;
  sort?: Record<string, "ASC" | "DESC">;
  enabled?: boolean;
}

interface UseProgramRequestsPaginatedParams extends UseProgramRequestsParams {
  page?: number;
}

export const useReceivedProgramRequestsPaginated = ({
  limit = REQUESTS_PAGE_LIMIT,
  page = 0,
  sort,
  enabled,
}: UseProgramRequestsPaginatedParams = {}) => {
  return useQuery({
    queryKey: [...GO_SERVICE_QUERY_KEYS.receivedProgramRequests(), { limit, page, sort }],
    queryFn: () => getReceivedProgramRequests({ limit, offset: page * limit, sort }),
    staleTime: 1000 * 60 * 5, // 5 minutes
    enabled,
  });
};

export const useReceivedProgramRequestsInfinite = ({
  limit = REQUESTS_PAGE_LIMIT,
  sort,
  enabled,
}: Omit<UseProgramRequestsParams, "offset"> = {}) => {
  return useInfiniteQuery({
    queryKey: [...GO_SERVICE_QUERY_KEYS.receivedProgramRequests(), { limit, sort }],
    queryFn: ({ pageParam = 0 }) => getReceivedProgramRequests({ limit, offset: pageParam * limit, sort }),
    getNextPageParam: (lastPage, allPages) => {
      const fetchedCount = allPages.length * limit;
      return fetchedCount < lastPage.data.meta.totalItems ? allPages.length : undefined;
    },
    initialPageParam: 0,
    enabled,
  });
};
